import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
} from "reactstrap";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import TablePagination from "views/components/TablePagination";
import InterviewModel from "models/Interview.model";
import Loader from "components/loader/Loader";

const Interview = ({ dataListTuotrs, getListDataByrefersh }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [interviewList, setInterviewList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const parmas = useParams();
  const [interviewId, setInterviewId] = useState();

  const getListDataByid = async (id) => {
    setInterviewId(id);
    console.log("----------------------------------------------->", id);
    setIsLoading(true);
    await tutorsModal
      .TeachingshInterviewQualifiedSubject(id)
      .then((result) => {
        setIsLoading(false);
        if (result) {
          console.log("--------------------result -----------------", result);
          setDataList(result?.data?.suject);
          setCurrentPage(result?.meta?.current_page);
          setPerPage(result?.meta?.per_page);
        }
      })
      .catch((error) => {
        console.log("--------------------error -----------------", error);
        setIsLoading(false);
      });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListDataByInterviewList = () => {
    setIsLoading(true);
    // Dummy data for testing
    const dummyData = [
      {
        id: 1,
        tutor_name: "John Doe",
        interviewer: "Jane Smith",
        interview_date: "2023-10-01",
        start_time: "10:00 AM",
        end_time: "11:00 AM",
        interview_link: "https://meet.google.com/abc",
        status: "scheduled",
        feedback: "Initial feedback",
      },
      {
        id: 2,
        tutor_name: "Alice Johnson",
        interviewer: "Bob Brown",
        interview_date: "2023-10-02",
        start_time: "02:00 PM",
        end_time: "03:00 PM",
        interview_link: "https://zoom.us/xyz",
        status: "completed",
        feedback: "Great performance",
      },
      {
        id: 3,
        tutor_name: "Charlie Wilson",
        interviewer: "Diana Lee",
        interview_date: "2023-10-03",
        start_time: "11:00 AM",
        end_time: "12:00 PM",
        interview_link: "https://teams.microsoft.com/def",
        status: "pending",
        feedback: "",
      },
    ];
    setInterviewList(dummyData);
    setCurrentPage(1);
    setPerPage(20);
    setIsLoading(false);
  };

  useEffect(() => {
    getListDataByInterviewList();
  }, []);

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const [modal1, setModal1] = useState(false);
  const toggle1 = () => setModal1(!modal1);

  const [interviewUserList, setInterviewUserList] = useState([]);
  const getListDatainterViewUSer = async () => {
    setIsLoading(true);
    await SubAdminModal.list()
      .then((result) => {
        setIsLoading(false);
        if (result) {
          setInterviewUserList(result.data);
        }
      })
      .catch((error) => {
        helper.sweetalert.toast(error.response?.data?.message, "warning");
      });
  };

  useEffect(() => {
    getListDatainterViewUSer();
  }, []);

  const [selectuser, setSelectdUser] = useState("");
  const interViewUser = (id) => {
    setSelectdUser(id);
  };

  const [selectStatus, setSelectdStatus] = useState("");
  const handleSelectStatus = (name) => {
    setSelectdStatus(name);
  };

  const [addsLoadig, setAddsLoadig] = useState(false);
  const navigate = useNavigate();

  const [meetingDate, setMeetingDate] = useState("");
  const handleDateChange = (event) => {
    const { value } = event.target;
    setMeetingDate(value); // Update meetingDate state with the selected date
  };
  const formattedDate = moment(meetingDate).format("YYYY-MM-DD");
  const [startTime, setStartTime] = useState(""); // State to store start time
  const [endTime, setEndTime] = useState(""); // State to store end time
  const [interviewLink, setInterViewLink] = useState("");

  // Function to handle changes in the start time input
  const handleStartTimeChange = (event) => {
    const { value } = event.target;
    setStartTime(value); // Update startTime state with the selected time
  };

  // Function to handle changes in the end time input
  const handleEndTimeChange = (event) => {
    const { value } = event.target;
    setEndTime(value); // Update endTime state with the selected time
  };

  const handleInterViewLink = (event) => {
    const { value } = event.target;
    setInterViewLink(value); // Update endTime state with the selected time
  };

  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const handleSubmitAddedInterView = (event) => {
    event.preventDefault();
    const formdata = new FormData();
    formdata.append("tutor_id", parmas?.mid);
    formdata.append("interviewer_id", selectuser);
    formdata.append("interview_link", interviewLink);
    formdata.append("interview_date", formattedDate);
    formdata.append("start_time", moment(startTime, "HH:mm").format("hh:mm A"));
    formdata.append("end_time", moment(endTime, "HH:mm").format("hh:mm A"));
    formdata.append("status", "scheduled");
    formdata.append("feedback", "");
    formdata.append("offering_details", "");
    setIsSaveLoading(true);
    InterviewModel.create(formdata)
      .then((response) => {
        getListDataByInterviewList();
        helper.sweetalert.toast("Interview Scheduled", "success");
        toggle();
        setIsSaveLoading(false);
      })
      .catch((error) => {
        //toggle();
        helper.sweetalert.toast(error.response.data.message, "error");
      });
  };

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  console.log(dataList, "sdjhfs");

  const [selectSubject, setSelectSubject] = useState([]);
  const handleChangeSubject = (e, index) => {
    const { checked, value } = e.target;
    setDataList((prevDataList) => {
      const newDataList = [...prevDataList]; // Copy the previous state
      if (checked) {
        // If the checkbox is checked, add the value to the preference array
        newDataList[index].preference.push(value);
      } else {
        // If the checkbox is unchecked, remove the value from the preference array
        const indexToRemove = newDataList[index].preference.indexOf(value);
        if (indexToRemove !== -1) {
          newDataList[index].preference.splice(indexToRemove, 1);
        }
      }

      const ids = newDataList.map((item) => item.id);
      setSelectSubject(ids);
      return newDataList; // Return the updated state
    });
  };

  const [feedback, setFeedback] = useState("");
  const handleChangeFeedback = (event) => {
    const { value } = event.target;
    setFeedback(value);
  };
  const [selecttOfferingDetails, setSelectOfferingDetails] = useState("");
  const handleChangeOfferingDetails = (event) => {
    const { value } = event.target;
    setSelectOfferingDetails(value);
  };

  const clerStateData = () => {
    setSelectOfferingDetails("");
    setFeedback("");
    setSelectSubject("");
  };
  const [modal2, setModal2] = useState(false);
  const toggle2 = () => {
    setSelectStatus("");
    clerStateData();
    setModal2(!modal2);
  };

  const handleSubmitStatusChange = (event) => {
    setAddsLoadig(true);
    event.preventDefault();
    const data = {
      id: interviewId,
      preference: selectSubject,
      feedback: feedback,
      offering_details: selecttOfferingDetails,
    };
    tutorsModal
      .interviewStatusChnage(data)
      .then((response) => {
        getListDataByrefersh();
        helper.sweetalert.toast("status update.", "success");
        clerStateData();
        getListDataByInterviewList();
        setAddsLoadig(false);
        toggle2();
      })
      .catch((error) => {
        setAddsLoadig(false);
        // console.log(error);
      });
  };

  const [selecttStatus, setSelectStatus] = useState("");
  const handleChangeStatus = (event) => {
    const { value } = event.target;
    setSelectStatus(value);
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div>
        <span>Interview List</span>
        <Button
          size="md"
          onClick={toggle}
          color="primary"
          style={{ float: "right", marginBottom: "10px" }}
        >
          Create Interview
        </Button>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table responsive>
          <thead>
            <tr style={{ background: "#F6F9FC" }}>
              <th id="tableheding">SN No.</th>
              <th id="tableheding">Tutor Name</th>
              <th id="tableheding">Interviewer Name</th>
              <th id="tableheding">Interviewe Date</th>
              <th id="tableheding">Time</th>
              <th id="tableheding"> Meet Link</th>
              <th id="tableheding">Status</th>
              <th id="tableheding">Feedback</th>
              <th id="tableheding">Action</th>
            </tr>
          </thead>
          <tbody>
            {interviewList.map((item, index) => (
              <tr
                key={item.id}
                className="vertical-align-middle"
                style={{ cursor: "pointer", verticalAlign: "middle" }}
              >
                <td id="tabledata">{index + 1}</td>
                <td id="tabledata">{item?.tutor_name || "-"}</td>

                <td id="tabledata">{item?.interviewer || "-"}</td>
                <td id="tabledata">{item?.interview_date || "-"}</td>
                <td id="tabledata">
                  {item?.start_time} - {item?.end_time || "-"}
                </td>
                <td id="tabledata">{item?.interview_link || "-"}</td>
                <td id="tabledata">{item?.status || "-"}</td>
                <td id="tabledata">{item?.feedback || "-"}</td>

                <td
                  id="tabledata"
                  className="p-4"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    // justifyContent: "center",
                    // alignItems: "center",
                  }}
                >
                  <UncontrolledTooltip
                    placement="top"
                    target={`eyeTooltip-${item.id}`}
                  >
                    Interview Status Change
                  </UncontrolledTooltip>
                  <p
                    style={{
                      margin: "0 5px",
                      fontSize: "15px",
                      color: "blue",
                      // backgroundColor: "#f5f5f5",
                      alignItems: "center",
                      display: "inline-block",
                      marginTop: "10px",
                      // padding: "5px", // Optional: Add padding for better appearance
                      borderRadius: "30%", // Optional: Make it a circle
                    }}
                    id={`eyeTooltip-${item.id}`}
                    onClick={() => {
                      getListDataByid(item.id);
                      toggle2();
                    }}
                  >
                    <i className="fa-solid fa-pen-to-square"></i>
                  </p>

                  <UncontrolledTooltip
                    placement="top"
                    target={`userTooltip-${item.id}`}
                  >
                    Cancel
                  </UncontrolledTooltip>
                  <p
                    style={{
                      margin: "0 8px",
                      fontSize: "15px",
                      color: "red",
                      marginTop: "10px",
                      // backgroundColor: "#f5f5f5",
                      display: "inline-block",
                      // padding: "5px", // Optional: Add padding for better appearance
                      borderRadius: "20%", // Optional: Make it a circle
                    }}
                    id={`userTooltip-${item.id}`}
                    // onClick={() => handleDel(item.id)}
                  >
                    <i className="fas fa-trash"></i>
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Interview Schedule Tutors</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="exampleEmail">Select Interviewer</Label>
                <Input
                  id="forType"
                  type="select"
                  onChange={(e) => {
                    interViewUser(e.target.value, "board");
                  }}
                >
                  <option value="">select Option</option>
                  {interviewUserList &&
                    interviewUserList.map((item, index) => {
                      return <option value={item.mobile}>{item.name}</option>;
                    })}
                </Input>
              </FormGroup>
            </Col>
            <Col md={12}>
              <FormGroup>
                <Label for="exampleEmail">Meeting Link (Inculde https) </Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="text"
                  placeholder="https://meet.google.com/yvs-yzvb-dfa"
                  value={interviewLink}
                  onChange={handleInterViewLink}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="meetingDate">Meeting Date</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="date"
                  id="meetingDate"
                  placeholder="Select meeting date"
                  value={meetingDate} // Set the value of the input field to the meetingDate state
                  onChange={handleDateChange} // Call handleDateChange function when the date is changed
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="startTime">Start Time</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="time"
                  id="startTime"
                  value={startTime} // Convert to 12-hour format
                  onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="endTime">End Time</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="time"
                  id="endTime"
                  value={endTime} // Convert to 12-hour format
                  onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                />
              </FormGroup>
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
            <Button
              color="primary"
              type="submit"
              style={{ float: "right", marginLeft: "5%" }}
              onClick={handleSubmitAddedInterView}
              disabled={isSaveLoading}
            >
              {isSaveLoading ? <Loader /> : "Save"}
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modal2} toggle={toggle2}>
        <ModalHeader toggle={toggle2}>
          <h4>Update Interview Status</h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmitStatusChange}>
            <Row>
              <Col md={12}>
                <Label>Status</Label>

                <Input type="select" onChange={handleChangeStatus} required>
                  <option value="">Select Status</option>
                  <option value="Qualified">Qualified</option>
                  <option value="NotQualified ">Not Qualified </option>
                </Input>
              </Col>
              {selecttStatus === "Qualified" ? (
                <div
                  style={{
                    marginLeft: "20px",
                    marginBottom: "10px",
                    marginTop: "10px",
                  }}
                >
                  <Label for="exampleEmail">Select Qualified Subject </Label>
                  {dataList?.length > 0 ? (
                    dataList?.map((item, index) => (
                      <div key={index}>
                        {index + 1}.
                        <Input
                          type="checkbox"
                          style={{ width: "20px", height: "20px" }}
                          onChange={(e) => handleChangeSubject(e, index)} // Pass the index to the handleChangeSubject function
                          value={item?.id} // Assuming data.id represents the value of the checkbox
                        />
                        {item?.preference?.map((data, dataIndex) => (
                          <span
                            key={dataIndex}
                            style={{
                              fontSize: "14px",
                              fontWeight: "bold",
                              marginLeft: "8px",
                            }}
                          >
                            {index === index && ( // Render items of the first row
                              <>
                                {dataIndex !== 0 && " / "}
                                {/* Add a separator after each item except the first one */}
                                {data?.name}
                              </>
                            )}
                          </span>
                        ))}
                      </div>
                    ))
                  ) : (
                    <p colSpan="6" style={{ color: "red", fontSize: "14px" }}>
                      No Subject found
                    </p>
                  )}
                </div>
              ) : null}
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Feedback</Label>
                  <Input
                    id="type"
                    name="Feedback"
                    type="textarea"
                    placeholder="Enter Feedback"
                    value={feedback} // Bind the feedback state to the input value
                    onChange={handleChangeFeedback}
                  />
                </FormGroup>
              </Col>
              {selecttStatus === "Qualified" && (
                <Col md={12}>
                  <FormGroup>
                    <Label for="exampleEmail">Offering Details</Label>
                    <Input
                      id="type"
                      name="Feedback"
                      type="textarea"
                      placeholder="Enter Offering Details"
                      value={selecttOfferingDetails} // Bind the feedback state to the input value
                      onChange={handleChangeOfferingDetails}
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggle2}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                onClick={handleSubmitStatusChange}
              >
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      <Modal isOpen={modal1} toggle={toggle1}>
        <ModalHeader toggle={toggle1}>
          <h4>Interview Schedule User List</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="exampleEmail">Select Interviewer</Label>
                <Input
                  id="forType"
                  type="select"
                  onChange={(e) => {
                    interViewUser(e.target.value, "board");
                  }}
                >
                  <option value="">select Option</option>
                  {interviewUserList &&
                    interviewUserList.map((item, index) => {
                      return <option value={item.mobile}>{item.name}</option>;
                    })}
                </Input>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="exampleEmail">Meeting Link</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="text"
                  // name="interview_link"
                  placeholder="Enter meeting link"
                  value={interviewLink} // Set the value of the input field to the meetingDate state
                  onChange={handleInterViewLink}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="meetingDate">Meeting Date</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="date"
                  id="meetingDate"
                  // name="interview_date"
                  placeholder="Select meeting date"
                  value={meetingDate} // Set the value of the input field to the meetingDate state
                  onChange={handleDateChange} // Call handleDateChange function when the date is changed
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="startTime">Start Time</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="time"
                  id="startTime"
                  value={startTime} // Convert to 12-hour format
                  onChange={handleStartTimeChange} // Call handleStartTimeChange function when the time is changed
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="endTime">End Time</Label>
                <Input
                  style={{
                    border: "1px solid lightgrey",
                    padding: "6px 10px",
                    borderRadius: "6px",
                  }}
                  type="time"
                  id="endTime"
                  value={endTime} // Convert to 12-hour format
                  onChange={handleEndTimeChange} // Call handleEndTimeChange function when the time is changed
                />
              </FormGroup>
            </Col>
            {/* <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Select Interviewer</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      interViewUser(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    <option value="">Pending</option>
                    <option value="">Interview scheduled</option>
                   
                  </Input>
                </FormGroup>
              </Col> */}
          </Row>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="secondary" onClick={toggle1}>
              Cancel
            </Button>
            <Button
              color="primary"
              type="submit"
              style={{ float: "right", marginLeft: "5%" }}
              //onClick={handleSubmitAddedInterView}
              //disabled={setIsSaveLoading}
            >
              Save
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <br />
    </div>
  );
};

export default Interview;
